export const roles = {
    ROLE_ADMIN_CUSTOMER: [
        { action: ['read', 'write'], resource: 'admin/users.*' },
        { action: ['list', 'edit', 'create'], resource: 'admin/users' },
        { type: 'deny', action: 'write', resource: 'admin/users.tab.histories' },
        { type: 'deny', action: 'write', resource: 'admin/users.tab.administrative', record: { verified: false } },
        { type: 'deny', action: 'write', resource: 'admin/users.first_name' },
        { type: 'deny', action: 'write', resource: 'admin/users.last_name' },
        { type: 'deny', action: 'write', resource: 'admin/users.phone' },
        { type: 'deny', action: 'write', resource: 'admin/users.mobile' },
        { type: 'deny', action: 'write', resource: 'admin/users.admin_roles' },
        { action: ['read', 'write'], resource: 'admin/addresses.*' },
        { action: ['read', 'write'], resource: 'admin/groups.*' },
        { action: ['list', 'edit'], resource: 'admin/groups' },
    ],
    ROLE_ADMIN_SAMPLING: [
        { action: ['read', 'write'], resource: 'admin/product/samples.*' },
        { action: ['list', 'edit', 'create'], resource: 'admin/product/samples'},
        { action: ['list', 'show'], resource: 'admin/orders', record: { type: 'sample' } },
        { action: ['read', 'write'], resource: 'admin/orders.*'},
    ],
    ROLE_ADMIN_INVERTORY: [
        { action: ['list', 'edit', 'delete'], resource: 'admin/products' },
        { action: ['read', 'write'], resource: 'admin/products.*' },
        { action: ['list', 'edit'], resource: 'admin/product/gallery.*' },
        { action: ['list', 'edit', 'create'], resource: 'admin/product/prices' },
        { action: ['read', 'write'], resource: 'admin/product/price.*' },
        { action: ['list', 'edit'], resource: 'admin/product/categories' },
        { action: ['write', 'read'], resource: 'admin/product/categories.*' },
        { action: ['list'], resource: 'admin/product/attributes' },
        { action: ['read'], resource: 'admin/product/attributes.*' },
        { action: ['list'], resource: 'admin/product/attribute-sets' },
        { action: ['read'], resource: 'admin/product/attribute-sets.*' },
        { action: ['list', 'edit', 'create', 'delete', 'clone'], resource: 'admin/product/samples' },
        { action: ['read', 'write'], resource: 'admin/product/samples.*' },
        { action: ['list', 'edit'], resource: 'admin/product/stock' },
        { action: ['write', 'read'], resource: 'admin/product/stock.*' },
    ],
    ROLE_ADMIN_SALES: [
        { action: ['list', 'show'], resource: 'admin/orders', record: { type: 'sample' } },
        { action: ['read', 'write'], resource: 'admin/orders.*'},
        { action: ['read'], resource: 'admin/users.*' },
        { action: ['list'], resource: 'admin/users' },
        { type: 'deny', action: 'write', resource: 'admin/users.tab.administrative' },
    ],
    ROLE_ADMIN_MARKETING: [
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/pages' },
        { action: ['read', 'write'], resource: 'admin/pages.*' },
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/articles' },
        { action: ['read', 'write'], resource: 'admin/articles.*' },
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/tags' },
        { action: ['read', 'write'], resource: 'admin/tags.*' },
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/categories' },
        { action: ['read', 'write'], resource: 'admin/categories.*' },
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/navigations' },
        { action: ['read', 'write'], resource: 'admin/navigations.*' },

        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/navigations/:navigationId/items' },
        { action: ['read', 'write'], resource: 'admin/navigations/:navigationId/items.*' },

        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/makers' },
        { action: ['read', 'write'], resource: 'admin/makers.*' },
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/maker/filters' },
        { action: ['read', 'write'], resource: 'admin/maker/filters.*' },
        { action: ['list', 'edit', 'create', 'delete'], resource: 'admin/faqs' },
        { action: ['read', 'write'], resource: 'admin/faqs.*' },
        { action: ['list', 'edit'], resource: 'admin/product/categories' },
        { action: ['read', 'write'], resource: 'admin/product/categories.*' },
        { type: 'deny', action: 'write', resource: 'admin/product/categories.slug' },
        { action: ['list', 'edit'], resource: 'admin/products' },
        { action: ['read', 'write'], resource: 'admin/products.*' },
        { action: ['read','write'], resource: 'admin/products.description' },
        { action: 'write', resource: 'admin/products.short_description' },
        { action: 'write', resource: 'admin/products.meta_title' },
        { action: 'write', resource: 'admin/products.meta_description' },
        { action: 'write', resource: 'admin/products.meta_keywords' },
        { action: '*', resource: 'admin/product/gallery' },
    ],
    ROLE_ADMIN: [
        { action: '*', resource: '*' },
        { type: 'deny', action: 'write', resource: 'admin/users.tab.administrative', record: { verified: false } },
        { type: 'deny', action: 'write', resource: 'admin/users.tab.histories', record: { verified: false } },
    ],
};
